<div
  class="RevolutionDealershipContactMoleculeComponent w-full min-w-fit h-fit"
  >
  @if (employee) {
    <mat-card
      class="p-6 gap-6 w-full h-fit !flex !flex-col !shadow-none !rounded-lg"
      [ngClass]="{ 'bg-mat-ef-revolution-grey-200': view !== 'appointment' }"
      >
      <div class="h-fit w-full flex gap-6 flex-col md:flex-row">
        <div
          class="flex-1 flex gap-6"
          [ngClass]="{ 'flex-col items-center': view === 'tracking' }"
          >
          <div class="h-18 w-18">
            @if (!showAltIcon) {
              <img
                class="object-cover rounded-full"
                [src]="profilePictureUrl"
                (error)="showAltIcon = true"
                alt=""
                />
            }
            @if (showAltIcon) {
              <mat-icon
                svgIcon="ef-logo-icon"
                class="!w-full !h-full !text-mat-ef-primary-500"
                >
              </mat-icon>
            }
          </div>
          <div class="flex-1 relative">
            @if (!disableEdit && view !== 'appointment' && !vehicle?.business) {
              <button
                data-cy="dealership-contact-molecule-editPrefferedemployee-button"
                mat-button
                mat-stroked-button
                color="secondary"
                (click)="!disableEdit && editPrefferedemployee()"
                class="revolution !hidden md:block !absolute top-0 right-0 small-button"
                >
                {{ 'update' | sharedTranslate }}
              </button>
            }
            <div
              class="text-xs text-mat-ef-revolution-primary-300"
              [ngClass]="{ 'text-center': view === 'tracking' }"
              >
              <T
              str="Your contact person"
              key="customerPortal.customer-portal.dealer.key-contact"
              tags="customer-portal, 3.1"
            ></T>
          </div>
          <div
            class="text-lg text-mat-ef-revolution-primary-500 font-bold"
            [ngClass]="{ 'text-center': view === 'tracking' }"
            >
            {{ employee.name }} {{ employee.familyName }}
          </div>
          @if (employee.functionRole) {
            <div
              class="text-base text-mat-ef-revolution-primary-500"
              [ngClass]="{ 'text-center': view === 'tracking' }"
              >
              <ng-container
              *ngTemplateOutlet="
                sharedService.template('transifexTranslation');
                context: {
                  key: 'customerPortal.customer-portal.' + employee.functionRole
                }
              "
            ></ng-container>
          </div>
        }
      </div>
    </div>
    @if (view === 'appointment') {
      <div
        class="flex-1 flex flex-col gap-x-12 text-mat-ef-revolution-secondary-500 justify-around"
        >
        <ng-container *ngTemplateOutlet="employeeTemplate"> </ng-container>
      </div>
    }
  </div>
  @if (view !== 'appointment') {
    <div
      class="h-fit w-full flex flex-col gap-x-12 gap-y-1 text-mat-ef-revolution-secondary-500 justify-between"
      [ngClass]="{
        'lg:flex-row': view !== 'tracking',
        'gap-y-4': view === 'tracking'
      }"
      >
      <ng-container *ngTemplateOutlet="employeeTemplate"> </ng-container>
    </div>
  }
</mat-card>
}
</div>

<ng-template #employeeTemplate>
  @if (employee.phone) {
    <div class="flex">
      <div>
        <mat-icon class="!h-5 !w-5 mr-2" svgIcon="phone"></mat-icon>
      </div>
      <a
        data-rel="external"
        class="text-sm font-semibold cursor-pointer"
      (click)="
        openPhoneCLient($event); sendOutboundLinkData('E-Mail Click', dealer)
      "
        >
        @if (phoneNumber?.mask) {
          <div>
            {{ phoneNumber.prefix }}
            {{ phoneNumber.number | mask: phoneNumber.mask }}
          </div>
        }
        @if (!phoneNumber?.mask) {
          <div>
            {{ employee.phone }}
          </div>
        }
      </a>
    </div>
  }
  @if (employee.email) {
    <div class="flex">
      <div>
        <mat-icon class="!h-5 !w-5 mr-2" svgIcon="mail"></mat-icon>
      </div>
      <a
        data-rel="external"
        class="text-sm font-semibold cursor-pointer"
      (click)="
        openEmailClient($event); sendOutboundLinkData('Phone Click', dealer)
      "
        >
        {{ employee.email }}</a
        >
      </div>
    }
    @if (view !== 'appointment' && dealer?.id) {
      <div class="flex">
        <div>
          <mat-icon class="!h-5 !w-5 mr-2" svgIcon="phone_callback"></mat-icon>
        </div>
        <div
          data-cy="request-callback-button-employee"
          class="text-sm font-semibold cursor-pointer"
          (click)="openCallRequestPopup(); $event.stopPropagation()"
          >
          <T
          str="Request a callback"
          key="customerPortal.customer-portal.support.callrequest"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    </div>
  }
  @if (!disableEdit && view !== 'appointment' && !vehicle?.business) {
    <button
      mat-button
      mat-stroked-button
      color="secondary"
    (click)="
      !disableEdit && editPrefferedemployee();
      sendOutboundLinkData('Phone Click', dealer)
    "
      class="revolution block md:hidden small-button"
      >
      {{ 'update' | sharedTranslate }}
    </button>
  }
</ng-template>
